export const importArrowKeyNavigation = () => import(
  'arrow-key-navigation'
)
